module.exports = __webpack_public_path__ + "static/media/01-_DSC8507.2089f45b.jpg";